import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@/lib/query';
import App from './App';
import { applyFontScale, getFontScale } from '@/lib/prefs/fontScale';
import '@/i18n';
import './styles/index.scss';

// A7: apply the saved font-size preference before first paint.
applyFontScale(getFontScale());

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// Made with Bob
